//@ts-ignore
export const pendo = window.pendo;
